module.exports = __webpack_public_path__ + "arrow-to-first.svg?0ad1bc087350da1fed4f3870bc42f70d";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/arrow-to-first.svg
// module id = 32
// module chunks = 0